import type { DoctorListItem } from '@dermalink/shared';
import { doctorPortraitUrl, getDoctorInitials } from '@/utils';

type Subject = Pick<DoctorListItem, 'picture_url' | 'first_name' | 'last_name'>;

// Renders a doctor's uploaded portrait if there is one, else their initials.
// The circle itself (size, ring, colors) is styled by the caller via
// `circleClassName` — each list treats it slightly differently.
export function DoctorAvatar({
  doctor, circleClassName, imageClassName,
}: {
  doctor: Subject;
  circleClassName: string;
  imageClassName: string;
}) {
  const portrait = doctorPortraitUrl(doctor);
  return (
    <span className={circleClassName} aria-hidden="true">
      {portrait ? <img src={portrait} alt="" className={imageClassName} /> : getDoctorInitials(doctor)}
    </span>
  );
}
